// Carry Roll FairwayHitProbability — P(in-play) from dispersion + fairway width (emergent TODO-10).

import { useState } from 'react';
import { ExpressionInput } from 'calc-controls';
import { useStore } from '../../store';
import { useResult } from '../../store/selectors';
import { handicapDispersion } from '@carry-roll/shared-logic';
import { pWithinHalfWidth } from '@carry-roll/shared-logic';
import { convertDistance } from '@carry-roll/shared-logic';
import { HelpTooltip } from '../calculator/HelpTooltip';

export function FairwayHitProbability() {
  const result = useResult();
  const distanceUnit = useStore((s) => s.distanceUnit);
  const fairwayWidthM = useStore((s) => s.fairwayWidthM);
  const [handicap, setHandicap] = useState(0);

  const spreadM = handicapDispersion(handicap);
  const halfWidthM = fairwayWidthM / 2;
  const p = pWithinHalfWidth(spreadM, halfWidthM);
  const pct = Math.round(p * 100);
  const widthDisplay = Math.round(convertDistance(fairwayWidthM, distanceUnit));

  return (
    <div className="panel" style={{ padding: 'var(--space-4)' }} data-testid="fairway-hit-probability">
      <h3 className="subsection-title">
        Fairway-hit probability
      </h3>
      <p className="text-xs mb-2" style={{ color: 'var(--color-text-muted)' }}>
        Chance of finishing within a {widthDisplay} {distanceUnit} fairway, based on handicap-scaled lateral dispersion.
        {result.carryM > 0 && ` Reference carry: ${Math.round(convertDistance(result.carryM, distanceUnit))} ${distanceUnit}.`}
      </p>
      <div className="flex items-baseline justify-between mb-2">
        <span className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          In-play
        </span>
        <span
          className="text-3xl font-bold"
          style={{ color: pct >= 50 ? 'var(--color-success)' : 'var(--color-warn)' }}
        >
          {pct}%
        </span>
      </div>
      <div className="block">
        <span className="field-label">
          Handicap
          <HelpTooltip label="Handicap">Scales expected lateral dispersion. Scratch ~8 m; each stroke adds ~0.8 m.</HelpTooltip>
        </span>
        <ExpressionInput
          inline
          value={handicap}
          onChange={setHandicap}
          unit="hcp"
          aria-label="Handicap"
          decimals={0}
          min={0}
          max={36}
        />
      </div>
    </div>
  );
}
